import React from 'react';
import _ from 'underscore';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Button, Grid, Divider, Segment, Accordion, Icon, Dialog, Modal, Header, Input, Dimmer, Loader } from 'semantic-ui-react';
import moment from 'moment'
import FormsInputsText from '../../../forms/inputs/text/forms_inputs_text';
import FormsInputDropdown from '../../../forms/inputs/dropdown';
import CommonUtility from '../../../../utils/CommonUtility';
import { USER_TYPE, USER_ROLES } from '../../../../constants';
import ListClientSelection from '../../client/list_client_selection';
import { getSystemAdminClients } from '../../../../actions'

const MEMBER_TYPE_OPTIONS = [
    { text: 'Dependent', value: 'd' },
    { text: 'Employee', value: 'e' }
];

const yesNoOptions = [
    { text: 'Yes', value: true },
    { text: 'No', value: false },
]

const filterOptions = [
    { key: 'companyName', text: 'Company Name', value: 'name' }, 
    { key: 'groupCode', text: 'Group Code', value: 'groupCode' },
    { key: 'policyNo', text: 'Policy No', value: 'policyNo' },
]
class UserFormCompanies extends React.Component {

    state = {
        activeIndexCompany: -1,
        activeIndexDependent: -1,
        openModalSelectCompany: false,
        indexSelectCompany: undefined,
        defaultCompany: this.props.user.companyId ? this.props.user.companyId : "",
        currentPage: 1,
        perPage: 10,
        totalPage: 1,
        totalData: 1,
        filter: 'name',
        query: '',
        clients: [],
        companyName:null,
        groupCode:null,
        policyNo:null,
        isLoading:false,
        isSearch: false
    }

    componentDidMount(){
        if(this.props.admin && this.state.clients.length === 0){
            this.getClients()
        }
    }

    getClients = () => {
        const { accessToken } = this.props.admin;

        let params = {}

        if (this.state.query !== '') {
            params[this.state.filter] = this.state.query
        }

        getSystemAdminClients({
            accessToken,
            searchPage: this.state.currentPage,
            searchMax: this.state.perPage,
            params
        }, (result, error) => {
            if(result && result.data) {
                if(result.data.pagination) {
                    this.setState({
                        totalPage: result.data.pagination.totalPage,
                        totalData: result.data.pagination.totalData,
                        isLoading: false,
                    })
                }
                if(result.data.clients) {
                    this.setState({
                        clients: result.data.clients,
                        isLoading: false,
                    })
                }
            }
        });
    }

    goToPreviousPage = () => {
        if (this.state.currentPage > 1) {
            this.setState({ isLoading: true, currentPage: this.state.currentPage - 1 }, () => {
                this.getClients();
            });
        };
    }

    goToNextPage = () => {
        let clientLength = this.state.clients ? this.state.clients : this.props.clients
        if (clientLength.length >= this.state.perPage) {
            this.setState({ isLoading: true, currentPage: this.state.currentPage + 1 }, () => {
                this.getClients();
            });
        };
    }

    setPage = (num) => {
        this.setState({ currentPage: num, isLoading: true }, () => {
            this.getClients();
        });
    }

    setPerPage = (num) => {
        this.setState({ perPage: num, isLoading: true,currentPage: 1 }, () => {
            this.getClients();
        });
    }

    submitFilter = () => {
        console.log({state: this.state})
        if (this.state.query !== '') {
            this.setState({...this.state, isLoading: true, currentPage: 1}, () => {
                this.getClients();
            });
        }
    }

    clearFilter = () => {
        this.setState({ query: '', isLoading: true, isSearch:false }, () => {
            this.getClients();
        });
    }

    checkClearFilter = (e) => {
        console.log('e.target.value: ', e.target.value)
        if(e.target.value === "" || e.target.value === null){
            this.setState({ query: '', isLoading: true }, () => {
                this.getClients();
            });
        }
        this.setState({ query: e.target.value })
    }

    onClickCompanyAccordion = (e, titleProps) => {


        const { index } = titleProps
        const { activeIndexCompany } = this.state
        const newIndex = activeIndexCompany === index ? -1 : index

        this.setState({ ...this.state, activeIndexCompany: newIndex })
    }

    onClickDependantAccordion = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndexDependent } = this.state;
        const newIndex = activeIndexDependent === index ? -1 : index

        this.setState({ ...this.state, activeIndexDependent: newIndex })

    }

    onSelectCompany(setFieldValue, companyId, companyName) {
        setFieldValue(`companies[${this.state.indexSelectCompany}].companyId`, companyId);
        setFieldValue(`companies[${this.state.indexSelectCompany}].companyName`, companyName);
        this.setState({
            ...this.state,
            openModalSelectCompany: false,
            indexSelectCompany: undefined
        })
    }

    showCompanyDialog(isShow, indexCompany) {
        if (isShow) {
            this.setState({
                ...this.state,
                openModalSelectCompany: true,
                indexSelectCompany: indexCompany
            })
        } else {
            this.setState({
                ...this.state,
                openModalSelectCompany: false,
                indexSelectCompany: undefined
            })
        }
    }

    onFilterDropdownChange = (e,{name, value}) => {    
        if(e.target.value === ""){
            this.setState({ filter: '' })
        } else {
            this.setState({ filter: value });
        }
    }

    render() { 

        const { user, admin } = this.props;
        const { activeIndexCompany, activeIndexDependent } = this.state
        const isAdminOperation = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_OPERATION], this.props.admin);
        const isAdminCallCentre = CommonUtility.haveUserType(USER_TYPE.SYS_ADMIN, this.props.admin) && CommonUtility.haveRoles([USER_ROLES.ADMIN_CALL_CENTRE], this.props.admin);
        
        return (
            <Formik
                initialValues={{
                    companies: user.companies.map(comp => {
                        const loginIDType = comp.companyDetail ? comp.companyDetail.featuresConfig.loginIDType : null;
                        const loginID = loginIDType ? loginIDType.toLowerCase() == 'email' ? this.props.user.email : loginIDType.toLowerCase() == 'nric' ? this.props.user.nric.toUpperCase() : comp.staffId.toUpperCase() : null;
                        const employee = comp.allRelatedUser && comp.allRelatedUser.length > 0 ? comp.allRelatedUser[0].name : null;
                        const isDefault = (user.companyId === comp.companyId) ? true : false;
                        const todayDate = moment().set({hour:0,minute:0,second:0,millisecond:0});
                        const todayTimestamp = todayDate.valueOf();
                        let isShowDefault = false
                        let startDateTimestamp = 0;
                        let endDateTimestamp = Number.MAX_VALUE;
                        if(comp.effectiveStartDate){
                            const effectiveStartDate = moment(comp.effectiveStartDate).set({hour:0,minute:0,second:0,millisecond:0});
                            startDateTimestamp = effectiveStartDate.valueOf();
                        }
                        
                        if(comp.effectiveEndDate){
                            const effectiveEndDate = moment(comp.effectiveEndDate).set({hour:0,minute:0,second:0,millisecond:0});
                            endDateTimestamp = effectiveEndDate.valueOf(); 
                        }
                        if(todayDate < endDateTimestamp){
                           isShowDefault = true
                        }

                        return ({
                            ...comp,
                            effectiveStartDate: comp.effectiveStartDate && moment(comp.effectiveStartDate).format('YYYY-MM-DD'),
                            effectiveEndDate: comp.effectiveEndDate && moment(comp.effectiveEndDate).format('YYYY-MM-DD'),
                            familyDetail: comp.familyDetail.map(fam => {
                                let specificCompany = fam.companies.find( data => data.companyId === comp.companyId) || {};
                                return {
                                    ...fam,
                                    effectiveStartDate: specificCompany.effectiveStartDate ? moment(specificCompany.effectiveStartDate).format('YYYY-MM-DD') : specificCompany.effectiveStartDate,
                                    effectiveEndDate: specificCompany.effectiveEndDate ? moment(specificCompany.effectiveEndDate).format('YYYY-MM-DD') : specificCompany.effectiveEndDate,
                                    planNo: specificCompany.planNo,
                                    birthdate: fam.birthdate ? moment(fam.birthdate).format('YYYY-MM-DD') : fam.birthdate,
                            }}),
                            loginID,
                            employee,
                            isDefault,
                            isShowDefault
                        })
                    })
                }}
                validateOnChange={false}
                validateOnBlur={false}
                // validationSchema={OutpatientValidationSchema}
                onSubmit={this.props.onSubmit}
                render={({
                    values,
                    errors,
                    status,
                    touched,
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => {

                    // Show loading UI
                    if(isSubmitting || this.props.loadingCompany){
                        return ( <Dimmer active inverted><Loader>Loading</Loader></Dimmer>)
                    }

                    return (
                        <Form>
                            <ListClientSelection
                                open={this.state.openModalSelectCompany}
                                clients={this.state.clients}
                                onSelectCompany={(companyId, companyName) => { this.onSelectCompany(setFieldValue, companyId, companyName) }}
                                onClose={()=>{ this.showCompanyDialog(false) }}
                                currentPage={this.state.currentPage }
                                perPage={this.state.perPage }
                                totalPage={this.state.totalPage }
                                totalData={this.state.totalData }
                                filter={this.state.filter}
                                query={this.state.query} 
                                submitFilter={ this.submitFilter.bind(this) }
                                clearFilter={ this.clearFilter.bind(this) }
                                checkClearFilter={this.checkClearFilter.bind(this)}

                                goToPreviousPage={ this.goToPreviousPage.bind(this) }
                                goToNextPage={ this.goToNextPage.bind(this) }
                                setPage={ this.setPage.bind(this) }
                                setPerPage={ this.setPerPage.bind(this) }

                                onFilterDropdownChange={this.onFilterDropdownChange.bind(this)}
                                filterOptions={filterOptions}
                                isLoading={this.state.isLoading}
                                // isSearch={this.state.isSearch}
                            />
                            <Segment>
                                <Grid container columns={1}>
                                    <Grid.Column width={16}>
                                        <Divider horizontal style={{ margin: "13px 0 0 0" }}> <Header as='h3'>User Companies</Header></Divider>
                                    </Grid.Column>
                                    <Grid.Column>
                                        {isAdminOperation && <Button type="button" color="blue" icon="plus" content="Add Company" onClick={() => {
                                            let comps = values.companies;
                                            comps.push({
                                                companyName: '',
                                                companyId: '',
                                                effectiveStartDate: '',
                                                effectiveEndDate: '',
                                                memberType: 'e',
                                                designation: '',
                                                planNo: '',
                                                costCenter: '',
                                                costCenterName: '',
                                                family: [],
                                                familyDetail: [],
                                                isNewCompany: true
                                            });
                                            setFieldValue("companies", comps);
                                            this.setState({ ...this.state, activeIndexCompany: comps.length - 1 })
                                        }} />

                                        }
                                    </Grid.Column>
                                    <Grid.Column>

                                        <FieldArray
                                            name="companies"
                                            render={arrayHelper => (
                                                <>
                                                    {Array.isArray(values.companies) && values.companies.map((comp, companyIndex) => {
                                                        return (
                                                            <React.Fragment key={companyIndex}>
                                                                <Accordion fluid styled style={{ marginBottom: "20px" }}>
                                                                    <Accordion.Title
                                                                        active={activeIndexCompany === companyIndex}
                                                                        index={companyIndex}
                                                                        onClick={this.onClickCompanyAccordion.bind(this)}
                                                                    >
                                                                        <Grid verticalAlign="middle">
                                                                            <Grid.Column width={10}>
                                                                                <Icon name='dropdown' />
                                                                                <span style={{ fontSize: "1.2rem", fontWeight: "800" }}>{comp.companyName || "New Company"}</span>
                                                                            </Grid.Column>
                                                                            <Grid.Column width={3} textAlign="center" disabled={true}>
                                                                                {isAdminOperation && !comp.isDefault && comp.isShowDefault &&
                                                                                    <Button type="button" size="tiny" color="blue" onClick={() => {
                                                                                        let ok = window.confirm("You are trying to set this company as default company. Are you sure? ");
                                                                                        if (ok) {
                                                                                            this.props.onChangeDefaultCompany(comp.companyId)
                                                                                        }
                                                                                    }}>Set default</Button>
                                                                                }
                                                                                {isAdminOperation && comp.isDefault &&
                                                                                    <Header size='small'>Default</Header>
                                                                                }
                                                                            </Grid.Column>
                                                                            <Grid.Column floated="right" width={3} textAlign="right" disabled={true}>
                                                                                {values.companies.length > 1 && isAdminOperation &&
                                                                                    <Button type="button" size="tiny" color="red" onClick={() => {
                                                                                        let ok = window.confirm("You are permanantly removing this company. Are you sure? ");
                                                                                        if (ok) {
                                                                                            this.props.removeCompanySingle(companyIndex, values)
                                                                                        }
                                                                                    }}>Remove</Button>
                                                                                }
                                                                            </Grid.Column>
                                                                        </Grid>
                                                                    </Accordion.Title>
                                                                    <Accordion.Content active={activeIndexCompany === companyIndex}>
                                                                        <Grid container columns={2} key={companyIndex} style={{ padding: "10px 10px" }}>
                                                                            <Grid.Column width={16}>
                                                                                <Field name={`companies[${companyIndex}].companyName`} label="Company Name" secondaryLabel="" >
                                                                                    {({ field }) => (
                                                                                        <>
                                                                                            <Header as='h5'>Company Name</Header>
                                                                                            { comp.isNewCompany ? 
                                                                                                <Input fluid {...field} labelPosition='right' placeholder='Select Company' content="Select Company" readOnly={true} label={
                                                                                                comp.isNewCompany ?
                                                                                                    <Button type="button" onClick={() => { this.showCompanyDialog(true, companyIndex) }}>Select Company</Button>
                                                                                                    : null
                                                                                            } />
                                                                                            : <Input fluid {...field} placeholder='Select Company' content="Select Company" readOnly={true} />
                                                                                            }
                                                                                        </>
                                                                                    )}
                                                                                </Field>
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].memberType`} label="Member Type" component={FormsInputDropdown} secondaryLabel="" options={MEMBER_TYPE_OPTIONS} disabled={true} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].staffId`} label="Staff ID" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].designation`} label="Designation" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].planNo`} label="Plan No" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].costCenter`} label="Cost Center" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].costCenterName`} label="Cost Center Name" component={FormsInputsText} secondaryLabel="" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].effectiveStartDate`} label="Effective Start Date" component={FormsInputsText} secondaryLabel="" type="date" disabled={!isAdminOperation} />
                                                                            </Grid.Column>
                                                                            <Grid.Column>
                                                                                <Field name={`companies[${companyIndex}].effectiveEndDate`} label="Effective End Date" component={FormsInputsText} secondaryLabel="" type="date" disabled={!isAdminOperation} />
                                                                            </Grid.Column>

                                                                            {/* --- Render dependent --- */}
                                                                            {comp.memberType === "e" && 
                                                                                <>
                                                                                    <Grid.Column width={16}>
                                                                                    </Grid.Column>
                                                                                    <Grid.Column width={16}>

                                                                                        <Divider horizontal style={{ margin: "13px 0 10px 0" }}> <Header as='h3'>Dependents data</Header></Divider>
                                                                                        <FieldArray
                                                                                            name={`companies[${companyIndex}].familyDetail`}
                                                                                            render={arrayHelper =>
                                                                                                (
                                                                                                    <React.Fragment>

                                                                                                        {isAdminOperation &&
                                                                                                            <>
                                                                                                                <Button type="button" primary onClick={() => arrayHelper.push({
                                                                                                                    companyName: '',
                                                                                                                    name: '',
                                                                                                                    nric: '',
                                                                                                                    birthdate: '',
                                                                                                                    relationship: '',
                                                                                                                    planNo: '',
                                                                                                                    effectiveStartDate: '',
                                                                                                                    effectiveEndDate: '',
                                                                                                                    loginRequired: 'Y',
                                                                                                                })}>Add Dependent</Button>
                                                                                                            </>
                                                                                                        }

                                                                                                        <Accordion>
                                                                                                            {values.companies[companyIndex].familyDetail.map((familyData, familyIndex) => {
                                                                                                                return (
                                                                                                                    <>
                                                                                                                        <>
                                                                                                                            <Accordion.Title
                                                                                                                                active={activeIndexDependent === familyIndex}
                                                                                                                                index={familyIndex}
                                                                                                                                onClick={this.onClickDependantAccordion.bind(this)}
                                                                                                                            >
                                                                                                                                <Grid verticalAlign='middle' >
                                                                                                                                    <Grid.Column width={12}>
                                                                                                                                        <Icon name='dropdown' />
                                                                                                                                        <span style={{ fontSize: "1.2rem", fontWeight: "800" }}>{familyData.name || "New Dependent"}</span>
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column floated="right" width={4} textAlign="right">
                                                                                                                                        {isAdminOperation && <Button type="button" size="tiny" color="red" onClick={() => {
                                                                                                                                            let ok = window.confirm("You are removing dependent. Please remember to save your changes by clicking the ‘Save’ button.");
                                                                                                                                            if (ok) {
                                                                                                                                                values.companies[companyIndex].familyDetail.splice(familyIndex, 1);
                                                                                                                                                setFieldValue('companies', values.companies);
                                                                                                                                            }
                                                                                                                                        }}>Remove</Button>}
                                                                                                                                    </Grid.Column>
                                                                                                                                </Grid>
                                                                                                                            </Accordion.Title>
                                                                                                                            <Accordion.Content active={activeIndexDependent === familyIndex}>
                                                                                                                                <Grid container columns={2} style={{ padding: "10px 20px" }}>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Name" name={`companies[${companyIndex}].familyDetail[${familyIndex}].name`} component={FormsInputsText} disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="NRIC" name={`companies[${companyIndex}].familyDetail[${familyIndex}].nric`} component={FormsInputsText} className="uppercase" disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Birthdate" name={`companies[${companyIndex}].familyDetail[${familyIndex}].birthdate`} component={FormsInputsText} type="date" disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Relationship" name={`companies[${companyIndex}].familyDetail[${familyIndex}].relationship`} component={FormsInputsText} disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Plan No" name={`companies[${companyIndex}].familyDetail[${familyIndex}].planNo`} component={FormsInputsText} disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Effective Start Date" name={`companies[${companyIndex}].familyDetail[${familyIndex}].effectiveStartDate`} component={FormsInputsText} type="date" disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                    <Grid.Column>
                                                                                                                                        <Field label="Effective End Date" name={`companies[${companyIndex}].familyDetail[${familyIndex}].effectiveEndDate`} component={FormsInputsText} type="date" disabled={!isAdminOperation} />
                                                                                                                                    </Grid.Column>
                                                                                                                                </Grid>
                                                                                                                            </Accordion.Content>
                                                                                                                        </>
                                                                                                                    </>
                                                                                                                )
                                                                                                            })}
                                                                                                        </Accordion>

                                                                                                    </React.Fragment>
                                                                                                )
                                                                                            }
                                                                                        >
                                                                                        </FieldArray>

                                                                                    </Grid.Column>
                                                                                </>
                                                                            }
                                                                            {/* --- End of Render dependent --- */}



                                                                        </Grid>
                                                                    </Accordion.Content>
                                                                </Accordion>
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </>

                                            )}>

                                        </FieldArray>



                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        {isAdminOperation && <Button type="submit" primary fluid size="big" >{this.props.submitText}</Button>}
                                    </Grid.Column>
                                    <Grid.Column width={16}>
                                        {this.props.renderSubmitResult instanceof Function && this.props.renderSubmitResult()}
                                    </Grid.Column>

                                </Grid>
                            </ Segment>
                        </Form>
                    )
                }}
            />

        )
    }

}

UserFormCompanies.defaultProps = {
    user: {},
    admin: {},
    clients: [],
    onSubmit: undefined,
    renderSubmitResult: undefined,
    submitText: "Save"
}

export default UserFormCompanies;

